<template>
  <div class="item">
    <!--a class="inner" :href="isLeft ? url1 : url2" target="'_blank"-->
    <div class="inner">
      <div class="image-box">
        <img :src="imgPath" alt="">
      </div>
      <div class="text-box">
        <p class="number" :class="size">
          <span class="small" v-if="small.length > 0" :data-content="small">{{small}}</span>{{number}}
        </p>
        <p>{{text}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProfilePaternosterItem",
    props: {
      image: {
        type: String
      },
      text: {
        type: String
      },
      number: {
        type: String
      },
      small: {
        type: String,
        default: ""
      },
      size: {
        type: String,
        default: "regular"
      },
      isLeft: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        imgPath: require('../assets/images/profile/' + this.image),
        url1: 'https://www.enercity.de/magazin/unsere-welt/kooperation-enercity-stadtwerke-quickborn',
        url2: 'https://www.enercity.de/magazin/deine-stadt/klimawende-hannover-wird-immer-gruener'
      }
    }
  }
</script>

<style scoped>
  .item {
    position: relative;
    display: block;
    padding: 15px;
    min-width: 260px;
  }
  .inner {
    position: relative;
    display: block;
    overflow: hidden;
    color: #102D61;
    text-decoration: none;
    transition: 0.3s ease;
  }
  .inner:after {
    content: "";
    position: relative;
    display: block;
    padding-top: 160%;
    background: linear-gradient(20deg, #B1D995 0%, #3CB2B8 100%);
    opacity: 0.85;
    transition: 0.3s ease;
  }
  .image-box img {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 0.3s ease;
  }
  /*
  .inner:hover .image-box img {
    transform: scale(1.05);
  }
  .inner:hover:after {
    opacity: 0.6;
  }
  */
  .text-box {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    justify-content: flex-end;
    z-index: 1;
    padding: 10%;
  }
  p {
    margin: 5px 0;
    font-size: 20px;
    line-height: 1.4;
  }
  .number {
    font-size: 110px;
    line-height: 1;
    margin: 5px -0.03em;
    font-weight: 700;
  }
  .number.smaller {
    font-size: 55px;
  }
  .small {
    font-size: 0.3em;
    font-weight: 500;
    margin-left: 0.02em;
  }
  .small[data-content="#"] {
    font-size: 0.6em;
  }
  @media(min-width: 768px) and (max-width: 999px) {
    .item {
      min-width: 300px;
    }
  }
  @media(max-width: 767px) {
    .item {
      padding: 10px;
    }
    .item:nth-child(4) ~ * {
      display: none;
    }
    p {
      font-size: 18px;
    }
    .number {
      font-size: 90px;
    }
    .number.smaller {
      font-size: 50px;
    }
  }
</style>